import { Grid } from '@mui/material';
import { FC } from 'react';
import InfoItemsList, { InfoItemsListProps } from './InfoItemsList';

const rightPart = {
    borderLeft: 1,
    borderLeftColor: 'grey.600',
    borderWidth: { md: 2, xs: 0 },
    pl: { md: 3, xs: 0 },
    pt: { md: 0, xs: 1 },
};

interface InfoItemsListsContainerProps {
    itemsListsData: InfoItemsListProps[];
    listIsFiltered?: boolean;
}

export const filterInfoItemsList = (itemsListsData: InfoItemsListProps[]) =>
    itemsListsData
        .map(({ fields, ...rest }) => ({
            fields: fields.filter(({ value }) => (Array.isArray(value) ? value.length : value)),
            ...rest,
        }))
        .filter(({ fields }) => fields.length);

const InfoItemsListsContainer: FC<InfoItemsListsContainerProps> = ({
    itemsListsData,
    listIsFiltered = false,
}) => {
    const filteredItems = listIsFiltered ? itemsListsData : filterInfoItemsList(itemsListsData);

    if (!filteredItems.length) return null;

    return (
        <>
            {filteredItems.map((blockData, index) => {
                const isLeftPart = index % 2 === 0;

                return (
                    <Grid
                        key={`details-block-${index + 1}-${blockData.title}`}
                        justifyContent="flex-start"
                        md={filteredItems.length > 1 ? 6 : 12}
                        sx={isLeftPart ? { pr: 3 } : rightPart}
                        xs={12}
                        item
                    >
                        <InfoItemsList {...blockData} lightFont />
                    </Grid>
                );
            })}
        </>
    );
};

export default InfoItemsListsContainer;
